import { features } from 'reactApp/mail-features';

const defaultHiddenConfig = {
    // tempexp_19379-start
    trialOnboarding: false,
    // tempexp_19379-end
    // tempexp_19378-next-line
    trial1tbBannerPromo: false,

    // tempexp_19377-start
    disableAdButton: {
        mainPage: false,
        public: false,
        viewer: false,
        worm: false,
    },
    // tempexp_19377-end
};

// Фича для выключения для оверквотеров различных частей Облака
export const hideOverquotaFeatures: typeof defaultHiddenConfig = features.getAsJSON('cloud-hide-overquota-features', defaultHiddenConfig);
